<template>
    <!--TODO 主要頁面-->
    <el-container class="BigContainer is-vertical" :class="[this.$public.isCordova()?'isApp': 'isWeb' , isShopArea? 'isShopArea': '']">

        <el-button v-show="isCloseBtn" type="text" id="closeBtn"/>

        <!--TODO 轉場-->
        <transition :name="transitionName" @after-leave="AfterLeave">
            <!--todo include為需要緩存的頁面，寫的是vue裡面的name，不是router的name-->
            <keep-alive :include="['Home', Gift ,SearchList ,ActivityIndex ,MarketplaceIndex, ArticleList]" max="3">
                <router-view class="BigMain" :class="{'hasTab' : showLayout === 'main' || showLayout === 'inside'}"/>
            </keep-alive>
        </transition>

        <!--TODO 底部-->
        <tab-bar v-if="(IsWideScreen && showLayout!==undefined)|| showLayout === 'main' || showLayout === 'inside'" @onButtonClick="onTabBarClick"
                 @onChange="onChange"/>

        <div class="footer-copyright"> copyright © 2024 LifeLink Cloud Co., Ltd.</div>

        <comm-dialog :value="publicCommDialogData.isShowDialog"
                     :outerContent="publicCommDialogData.outerContent"
                     :mainContent="publicCommDialogData.mainContent"
                     :isCancel="publicCommDialogData.isCancel"
                     :isConfirm="publicCommDialogData.isConfirm"
                     :icon="publicCommDialogData.icons"
                     @result="onPublicDialogResult"/>
    </el-container>
</template>

<script>
    import TabBar from '@/components/TabBar.vue';
    import * as constDefine from '@/store/constDefine';
    import CommDialog from '@/components/CommDialog.vue';
    import * as mutationTypes from "@/store/mutationTypes";
    import {getCryptoUserInfo, replaceUserInfo, replaceUserPhone} from "@/util/cryptoLocalStorage";

    export default {
        name: "MainPage",
        components: {TabBar, CommDialog},
		computed: {
			showLayout: function(){
				return this.$route.meta.showLayout;
			},
		},
        data() {
            return {
                defaultPublicCommDialogData: {},
                publicCommDialogData: {},
                isClickNotification: false,     //是否點了推播進 app的？
                fcmToken: '',
                //轉場名稱
                transitionName: '',
                //主題活動緩存
                ActivityIndex:'',
                //商圈夜市緩存
                MarketplaceIndex:'',
                //搜尋列表緩存
                SearchList:'',
                //禮物盒緩存
                Gift:'',
                //專欄文章緩存
                ArticleList:'',
                //是否為寬螢幕
                IsWideScreen: false,
                isCloseBtn: false,
                isShopArea: false,
            }
        },
        watch: {
            //showLayout共用 inside、inside-no-tab、single、main
            //inside、inside-no-tab轉場由右進入
            //single轉場由下進入
            //main無轉場效果-五個主頁用
            $route(to, from) {
                //觸發路徑轉換時就發出跳頁記錄
                this.$public.addGAEventViewName(`Go_${to.name}_Page`);
                this.$store.commit("setIsMainCloseBtn", false);

                if(to.meta.showLayout === 'inside' || to.meta.showLayout === 'inside-no-tab'){
                    if(from.meta.showLayout === 'single'){
                        this.transitionName = '';
                    }else{
                        this.transitionName = 'slideR';
                    }
                }else if(to.meta.showLayout === 'single'){
                    if(from.meta.showLayout === 'main' || from.meta.showLayout === 'inside' || from.meta.showLayout === 'inside-no-tab'){
                        this.transitionName = 'slideUp';
                    }else{
                        this.transitionName = '';
                    }
                }else if(to.meta.showLayout === 'main'){
                    if(from.meta.showLayout === 'inside' || from.meta.showLayout === 'inside-no-tab'){
                        this.transitionName = 'slideR-back';
                    }else if(from.meta.showLayout === 'single'){
                        this.transitionName = 'slideUp-back';
                    }else{
                        this.transitionName = '';
                    }
                }else {
                    this.transitionName = '';
                }
                //緩存
                if(to.name==='Search' || to.name==='Home' || to.name==='Complex' || to.name==='Login'|| to.name==='More' || from.name === 'Notify'){
                    this.SearchList=''
                    this.MarketplaceIndex=''
                    this.ActivityIndex=''
                    this.Gift=''
                }else {
                    this.SearchList='SearchList'
                    this.ActivityIndex='ActivityIndex'
                    this.Gift='Gift'
                    if(this.$public.isCordova()){
                        this.MarketplaceIndex='MarketplaceIndex'
                    }
                }
                if(to.name==='Home' || to.name==='ArticleList' || to.name==='ArticleDetail'){
                    this.ArticleList='ArticleList'
                }else {
                    this.ArticleList=''
                }
            },
            '$store.state.publicCommDialogData.isShowDialog': function() {
              this.publicCommDialogData = JSON.parse(JSON.stringify(this.$store.state.publicCommDialogData));
            },
            '$store.state.isMainCloseBtn': function() {
                this.isCloseBtn = this.$store.state.isMainCloseBtn;
            }
        },
        created() {

            //檢查 & 個資加密更新
            replaceUserInfo();
            replaceUserPhone();

            //監聽到返回時就增加返回的動畫
            window.addEventListener("popstate", function(e) {
                document.getElementById('app').classList.add("backAni");
            }, false);

            if(!this.$public.isCordova()) {
              if(process.env.VUE_APP_MODE !== "debug") {
                let allowRouterAry = ["TableOrder", "TableOrderRecord", "TableOrderComplete", "OrderList", "OrderDetail", "OrderCart", "WebStoreInfo" ,
                    "MarketplaceInfo","Product","Cart","ProductList","More","StoreInfo","Login","History","Form","TicketDetail","UsefulStoreList", "Account",
                    "MarketplaceArticleDetail", "MarketplaceActivityDetail" ,"MarketplaceActivity" , "MarketplaceArticle", "PrivacyPolicy", "LineLiffScanCode",
                    "WebStoreMember" , "WebStoreRewardPoint" , "WebStoreCoupon" , "WebStoreLoyaltyCard" , "WebStoreOinCard" , "MarketplaceGift", "LinepayConfirm"];
                if(allowRouterAry.indexOf(this.$route.name) === -1) {
                    this.$router.push({name:'Error'});
                }
              }
            }
        },
        mounted() {
            this.defaultPublicCommDialogData = JSON.parse(JSON.stringify(this.$store.state.publicCommDialogData));

            //檢查推播權限，有權限就直接進行推播設定
            this.checkNotificationPermission(false);

            this.initGoogleAnalytics();
            let self = this;
            //app啓動，只有啓動時才會觸發，如果之前都沒開過 app，點推播開啓 app時會觸發 deviceready
            document.addEventListener('deviceready', function () {
                self.procUrlClick();
                self.$store.commit('setCartStoreId',Number(window.localStorage.getItem('cartStoreId')));

                //啓動畫面截取監聽
                if (self.$public.notNull(window.plugins.preventscreenshot)) {
                    window.plugins.preventscreenshot.enable(self.successCallbackScreenshot, self.errorCallbackScreenshot);
                    // window.plugins.preventscreenshot.disable(successCallback, errorCallback);
                }

            }, false);

            //app 回到前景，每次從背景回到前景都會觸發，點推播開啓 app時，如果短時間內已開過 app，就會觸發 resume
            document.addEventListener('resume', function () {
                self.isClickNotification = false;
                self.$public.addGAEventLog("resume_OinApp", {});

                self.procUrlClick();
            }, false);

            //監聽裝置寬度
            this.windowWidth()
            window.onresize = () => {
                this.windowWidth()
            }

        },
        methods: {

            /** 處理點擊導向 */
            procUrlClick: function() {
                let self = this;
                if (!self.isClickNotification) {
                    //app導向 api
                    self.callUrlClickApi("iPhone SE")
                        .then( data => {
                            if (self.$public.notNull(data)) {
                                let paramStr = data.param;
                                let paramObj = JSON.parse('{"' + decodeURI(paramStr).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');

                                if (self.$public.notNull(paramObj)) {
                                    switch (data.type) {
                                        //判斷點擊的連結 type，是否爲導向？
                                        case constDefine.REDIRECT_TYPE_REDIRECT: {
                                            //判斷是否爲點餐？以及點餐的參數、有否登入等等該有的參數是否都有？
                                            if (self.$public.clickRedirectRouter(paramObj, constDefine.REDIRECT_ACTION_ORDER)) {
                                                return self.callCanRedirectOrderApi(Number(paramObj.storeId));
                                            }
                                            break;
                                        }
                                        default :
                                            break;
                                    }
                                }
                            }
                        })
                        .catch( (error) => {

                        });
                }
            },

            /** 檢查是否有點擊導向的記錄 */
            callUrlClickApi : function(deviceInfo) {
                let self = this
                return new Promise(function(resolve, reject) {

                    self.$http.fetchClickUrlApi`CheckUrlClick${`com.lifelink.oin`}${{
                        deviceInfo: deviceInfo,        //deviceInfo 的內容主要爲裝置辨識token，但目前還沒訂出來
                    }}${ json => {
                        // self.isLoading = false;
                        if (json.status) {
                            if (self.$public.notNull(json.data) && json.data !== '') {
                                //先把參數轉成的物件存起來
                                // self.$public.saveAppRedirectParam(paramObj);
                                //判斷參數類型然後做第一階段跳頁，第二階段要到那個頁面再補
                                // self.$public.clickRedirectRouter(json.data.type, paramObj);
                                resolve(json.data);

                            } else {
                                resolve(null);
                            }
                        } else {
                            resolve(null);
                        }
                    }}` ;
                });
            },

            /** 呼叫 取得店家參數開關api */
            callCanRedirectOrderApi (storeId) {
                let self = this;

                //取得店家參數開關
                return new Promise(function(resolve, reject) {
                    self.$http.fetchWithAuth`GetStoreParameter${{
                        id: storeId,
                    }} ${json => {
                        if (self.$public.notNull(json.data)) {
                            //回傳資料
                            // {"bookingStatus":1,"bookingUrl":"app/39/home","brandId":13,"brandName":"Gottone","editBookingUrl":"app/","feedbackStatus":1,"id":39,"isFollow":false,"name":"健康旗艦店","onlineOrderStatus":true,"qAStatus":1,"recommendStatus":true}}
                            //判斷是否有加會員以及店家是否有開啓點餐
                            if (json.data.isFollow && json.data.onlineOrderStatus) {
                                self.$router.push({name: 'OrderList', query:{id: json.data.id}});
                            }
                            resolve();

                        } else {
                            reject(`CanRedirectOrder: 無法取得資料`);
                        }
                    }}`;
                });
            },

            //(退場)漸變動畫執行完畢後
            AfterLeave(){
                document.getElementById('app').classList.remove("backAni");
            },
            /*BeforeLeave(){
                if(this.$route.meta.showLayout==="main"){
                    this.countDownTimer()
                }else{
                    window.WkWebView.allowsBackForwardNavigationGestures(true) // 關閉ios原生側滑返回
                }
            },*/


            /** 上傳新的 fcm token */
            updateFcmToken: function () {
                let self = this;

                this.$http.fetchWithAuth`UpdateDeviceToken${{
                    'token': self.fcmToken,
                    'os': self.$http.getOS(),
                }}`;

            },

            /** 初始 Google Analytics */
            initGoogleAnalytics: function () {
                let self = this;

                if (self.$auth.isAdminLogin()) {

                    const userData = getCryptoUserInfo();

                    if (self.$public.notNull(userData.nickName) && userData.nickName !== '') {
                        self.$public.addGAEventLog("launch_OinApp", {userName: userData.nickName});
                    } else {
                        self.$public.addGAEventLog("launch_OinApp", {userName: ""});
                    }

                } else {
                    self.$public.addGAEventLog("launch_OinApp", {userName: ""});
                }

            },

            /** 清空 fcm token */
            clearFcmToken: function () {
                let self = this;

                this.$http.fetchWithAuth`ClearTokenUserId${{
                    'token': self.fcmToken,
                    'os': self.$http.getOS(),
                }}`;
            },

            /**
             * 檢查推播權限
             * @param: requested:是否已有要求過權限？ (傳 true "不會"要求權限)
             * 如果檢查後是沒有權限的，傳 false會立即要求權限
             * */
            checkNotificationPermission: function(requested){
                let self = this;
                if (window.FirebasePlugin) {
                    let FirebasePlugin = window.FirebasePlugin;
                    FirebasePlugin.hasPermission(function (hasPermission) {
                        if (hasPermission) {
                            // 有推播權限後一定要做的事
                            // getToken();
                            self.fcmSetting();

                        } else if (!requested) {
                            // Request permission
                            FirebasePlugin.grantPermission(function(hasPermission){
                                self.checkNotificationPermission(true);
                            });
                        } else {
                            // Denied

                        }
                    });
                }
            },

            /** 推播處理設定 */
            fcmSetting: function () {
                let self = this;
                if (window.FirebasePlugin) {
                    let FirebasePlugin = window.FirebasePlugin;

                    //取得本機的 fcm token並更新
                    FirebasePlugin.onTokenRefresh(function (token) {
                        window.localStorage.setItem(constDefine.KEY_FCM_TOKEN, token);
                        self.fcmToken = token;
                        if (self.$auth.isAdminLogin()) {
                            self.updateFcmToken();
                        }
                    }, function (error) {

                    });

                    //Register handlers
                    FirebasePlugin.onMessageReceived(function (message) {
                        try {
                            if (message.messageType === "notification") {
                                self.$public.showNotify(message.body.toString(), 'info', 5000);

                                if (message.tap) {
                                    //不在app時,點擊背景推播訊息後進入
                                    // obj.getNotificationUnreadNumber();//更新未讀數量
                                    self.isClickNotification = true;
                                    self.goPageByAction(message);

                                } else {
                                    // self.getNotificationUnreadNumber();//更新未讀數量
                                    //Notification was received in foreground. Maybe the user needs to be notified.
                                    self.UpdatePageByAction(message);
                                }
                            } else {
                                // messageType === "data"
                                self.goPageByAction(message);
                            }
                        } catch (e) {
                            self.$public.showNotify("Failed :" + e, 'Notification Error', 2000);
                        }

                    }, function (error) {
                        self.$public.showNotify("Failed :" + error, 'Notification Error', 2000);
                    });

                }
            },

            /** 判斷 action 來跳頁 */
            goPageByAction: function (data) {
                let self = this
                let routerName = this.$route.name;

                //留言回覆(FeedBackList)、集點卡(點數)兌換(LoyaltyCardExchange)、訂位/取消訂位(GoToBooking)、候位(WaitingCall)、叫號()無法再到詳細頁面
                //不在app時,點擊背景推播訊息後進入
                switch (data.action) {
                    case constDefine.ACTION_FEEDBACK_LIST: {
                        //意見反映
                        if (this.$auth.isAdminLogin()) {
                            // this.$router.push({name: 'Feedback'});
                        }
                        break;
                    }
                    case constDefine.ACTION_FINISH_ORDER: {
                        //跳到消費明細
                        // let orderSn = data.orderSn;
                        // if (this.$auth.isAdminLogin()) {
                        //     this.$router.push({name: 'HistoryContent', params: {'orderSn': orderSn, 'openType': 'fmt'}});
                        // }
                        break;
                    }
                    case constDefine.ACTION_SEND_COUPON: {
                        //如果是點擊背景推播訊息後進入 app
                        let couponId = data.couponId.toString();

                        let type = data.type;
                        if (this.$auth.isAdminLogin()) {
                          this.$sqlite.insert('insert into gift_read (type, gift_id) values (?, ?);', [type, couponId]);
                          if(routerName === 'Gift') {
                            this.$store.commit('setChangePageData',{
                              isChangePage:   true,
                              activeCategory: 'coupon',
                              activeTab:      'use',
                            });
                          } else {
                            // this.$router.push({name: 'Gift', params:{activeCategory: 'coupon', activeTab: 'use'}});
                            this.$store.commit('setChangePageData',{
                              isChangePage:   true,
                              activeCategory: 'coupon',
                              activeTab:      'use',
                            });
                          }
                        }
                        break;
                    }
                    case constDefine.ACTION_SEND_REWARD:
                        break;
                    case constDefine.ACTION_GIFT_COUPON: {
                      //跳到禮物盒-優惠卷
                      if (this.$auth.isAdminLogin()) {
                        let couponListId = data.couponListId;
                        let type = data.type;
                        this.$sqlite.insert('insert into gift_read (type, gift_id) values (?, ?);', [type, couponListId]);
                        if(routerName === 'Gift') {
                          this.$store.commit('setChangePageData',{
                            isChangePage:   true,
                            activeCategory: 'coupon',
                            activeTab:      'use',
                          });
                        } else {
                          // this.$router.push({name: 'Gift', params:{activeCategory: 'coupon', activeTab: 'use'}});
                          this.$store.commit('setChangePageData',{
                            isChangePage:   true,
                            activeCategory: 'coupon',
                            activeTab:      'use',
                          });
                        }
                      }
                      break;
                    }
                  case constDefine.ACTION_GO_OIN_CARD: {
                    //跳到禮物盒-活動卡
                    if (this.$auth.isAdminLogin()) {
                      let id = data.id;
                      let type = data.type;
                      this.$sqlite.insert('insert into gift_read (type, gift_id) values (?, ?);', [type, id]);
                      if(routerName === 'Gift') {
                        this.$store.commit('setChangePageData',{
                            isChangePage:   true,
                            activeCategory: 'oinCard',
                            activeTab:      'use',
                        });
                      } else {
                        // this.$router.push({name: 'Gift', params:{activeCategory: 'oinCard', activeTab: 'use'}});
                        this.$store.commit('setChangePageData',{
                          isChangePage:   true,
                          activeCategory: 'oinCard',
                          activeTab:      'use',
                        });
                      }
                    }
                    break;
                  }
                  case constDefine.ACTION_GO_REGISTER_GIFT: {
                    //跳到禮物盒-活動卡
                    if (this.$auth.isAdminLogin()) {
                      if(routerName === 'Gift') {
                        this.$store.commit('setChangePageData',{
                          isChangePage:   true,
                          activeCategory: 'oinCard',
                          activeTab:      'use',
                        });
                      } else {
                        // this.$router.push({name: 'Gift', params:{activeCategory: 'oinCard', activeTab: 'use'}});
                        this.$store.commit('setChangePageData',{
                          isChangePage:   true,
                          activeCategory: 'oinCard',
                          activeTab:      'use',
                        });
                      }
                    }
                    break;
                  }
                  case constDefine.ACTION_GO_COUPON: {
                    //跳到禮物盒-優惠卷
                    if (this.$auth.isAdminLogin()) {
                      let id = data.id || data.couponId;
                      let type = data.type;
                      if (id > 0 && type === "coupon") {
                          this.$sqlite.insert('insert into gift_read (type, gift_id) values (?, ?);', [type, id]);
                      }
                      if(routerName === 'Gift') {
                        this.$store.commit('setChangePageData',{
                          isChangePage:   true,
                          activeCategory: 'coupon',
                          activeTab:      'use',
                          type:           type,
                        });
                      } else {
                        // this.$router.push({name: 'Gift'});
                        this.$store.commit('setChangePageData',{
                          isChangePage:   true,
                          activeCategory: 'coupon',
                          activeTab:      'use',
                          type:           type,
                        });
                      }
                    }
                    break;
                  }
                  case constDefine.ACTION_ONLINE_ORDER: {
                    //跳到點餐
                    if (this.$auth.isAdminLogin()) {

                      let changePage = function() {
                        if(routerName === 'OrderRecordDetail') {
                          self.$store.commit('setChangePageData',{
                            isChangePage:   true,
                            isChangeOrderSn:true,
                            takeoutId:      data.takeoutId,
                            orderSn:        data.orderSn,
                            type:           data.type,
                            status:         data.status,
                            cancelReason:   (typeof data.cancelReason === 'undefined' ? '' : data.cancelReason),
                          });
                        } else {
                          self.$store.commit('setChangePageData',{
                            isChangePage: false,
                            type:         data.type,
                          });
                          // self.$router.push({name: 'OrderRecordDetail',query:{orderSn: data.orderSn}});
                        }
                      }

                      switch (data.type) {
                        case 'AcceptOrder':
                          this.$store.commit('increasePrepareCount',1);
                          changePage();
                          break;
                        case 'RejectOrder':
                        case 'CompleteMeal':
                          this.$store.commit('increasePrepareCount',-1);
                          changePage();
                          break;
                        case 'CompleteOrder':
                          this.$store.commit('increasePrepareCount',-1);
                          changePage();
                          break;
                        case 'CancelOrder':
                          this.$store.commit('increasePrepareCount',-1);
                          changePage();
                          break
                        default :
                          break;
                      }
                    }
                    break;
                  }
                  case constDefine.ACTION_GO_BOOKING_RECORD: {
                    // this.$router.push({name: 'BookRecord', query:{storeId: 'allStore'}});
                    break;
                  }
                  case constDefine.ACTION_AMOUNT_EXCHANGE_COUPON: {
                    let couponId = data.couponId.toString();
                    let type = data.type;
                    this.$sqlite.insert('insert into gift_read (type, gift_id) values (?, ?);', [type, couponId]);
                    if(routerName === 'Gift') {
                      this.$store.commit('setChangePageData',{
                        isChangePage:   true,
                        activeCategory: 'coupon',
                        activeTab:      'use',
                      });
                      this.$store.commit(mutationTypes.setPublicCommDialogData,{
                        isShowDialog: true,
                        outerContent: data.msg,
                        isResultEvent: true,
                        eventName: constDefine.ACTION_AMOUNT_EXCHANGE_COUPON,
                      });
                    } else {
                      // this.$router.push({name: 'Gift', params:{activeCategory: 'coupon', activeTab: 'use'}});
                      //避免特殊情況沒執行換頁，所以這邊要保留
                      this.$store.commit('setChangePageData',{
                        isChangePage:   true,
                        activeCategory: 'coupon',
                        activeTab:      'use',
                      });
                      this.$store.commit(mutationTypes.setPublicCommDialogData,{
                        isShowDialog: true,
                        outerContent: data.msg,
                        isResultEvent: false,
                        eventName: constDefine.ACTION_AMOUNT_EXCHANGE_COUPON,
                      });
                    }
                    break;
                  }
                  case constDefine.ACTION_LOYALTY_CARD_EXCHANGE: {
                    if(routerName === 'LoyaltyCardExchange' || routerName === 'LoyaltyCardExchangeDetail') {
                      this.$store.commit(mutationTypes.setPublicCommDialogData,{
                        isShowDialog: true,
                        outerContent: data.msg,
                        isResultEvent: true,
                        eventName: constDefine.ACTION_LOYALTY_CARD_EXCHANGE,
                      });
                    }
                    break;
                  }
                  case constDefine.ACTION_GO_LOYALTY_CARD: {
                    //跳到禮物盒-集點卡
                    if (this.$auth.isAdminLogin()) {
                      let id = data.id;
                      let type = data.type;
                      this.$sqlite.insert('insert into gift_read (type, gift_id) values (?, ?);', [type, id]);
                      // this.$router.push({ name: 'LoyaltyCardPage', query:{id: id, activeCategory: type}})
                    }
                    break;
                  }
                    case constDefine.ACTION_GO_Gift_Pack_Detail: {
                        let id = data.id.toString();
                        let type = data.type;
                        if (this.$auth.isAdminLogin()) {
                            this.$sqlite.insert('insert into gift_read (type, gift_id) values (?, ?);', [type, id]);
                            if(routerName === 'Gift') {
                                this.$store.commit('setChangePageData',{
                                    isChangePage:   true,
                                    activeCategory: 'coupon',
                                    activeTab:      'use',
                                });
                            } else {
                                this.$store.commit('setChangePageData',{
                                    isChangePage:   true,
                                    activeCategory: 'coupon',
                                    activeTab:      'use',
                                });
                            }
                        }
                        break;
                    }
                  default :
                      break;
                }

                //跳到對應的頁面
                this.$public.clickNotificationRouter( JSON.stringify(data), routerName);
            },
            UpdatePageByAction: function (data) {
              let self = this
              let routerName = this.$route.name;
              //在app時收到推播訊息
              switch (data.action) {
                case constDefine.ACTION_SEND_COUPON: {
                  if (this.$auth.isAdminLogin()) {
                    let couponId = data.couponId.toString();
                    let type = data.type;
                    this.$sqlite.insert('insert into gift_read (type, gift_id) values (?, ?);', [type, couponId]);
                  }
                  break;
                }
                case constDefine.ACTION_GIFT_COUPON: {
                  if (this.$auth.isAdminLogin()) {
                    let couponListId = data.couponListId;
                    let type = data.type;
                    this.$sqlite.insert('insert into gift_read (type, gift_id) values (?, ?);', [type, couponListId]);
                  }
                  break;
                }
                case constDefine.ACTION_GO_COUPON: {
                  //跳到禮物盒-優惠卷
                  if (this.$auth.isAdminLogin()) {
                    let id = data.id || data.couponId;
                    let type = data.type;
                    if (id > 0 && type === "coupon") {
                      this.$sqlite.insert('insert into gift_read (type, gift_id) values (?, ?);', [type, id]);
                    }
                  }
                  break;
                }
                case constDefine.ACTION_GO_OIN_CARD: {
                  if (this.$auth.isAdminLogin()) {
                    let id = data.id;
                    let type = data.type;
                    this.$sqlite.insert('insert into gift_read (type, gift_id) values (?, ?);', [type, id]);
                  }
                  break;
                }
                case constDefine.ACTION_ONLINE_ORDER: {
                  //跳到點餐
                  if (this.$auth.isAdminLogin()) {
                    let changePage = function() {
                      if(routerName === 'OrderRecordList' || routerName === 'OrderRecordDetail' || routerName === 'OrderHelp') {
                        self.$store.commit('setChangePageData',{
                          isChangePage:   true,
                          isChangeOrderSn:false,
                          takeoutId:      data.takeoutId,
                          orderSn:        data.orderSn,
                          type:           data.type,
                          status:         data.status,
                          cancelReason:   (typeof data.cancelReason === 'undefined' ? '' : data.cancelReason),
                        });
                      }
                    }


                    switch (data.type) {
                      case 'AcceptOrder':
                        this.$store.commit('increasePrepareCount',1);
                        changePage();
                        break;
                      case 'RejectOrder':
                      case 'CompleteMeal':
                        this.$store.commit('increasePrepareCount',-1);
                        changePage();
                        break;
                      case 'CompleteOrder':
                        this.$store.commit('increasePrepareCount',-1);
                        changePage();
                        break;
                      case 'CancelOrder':
                        this.$store.commit('increasePrepareCount',-1);
                        changePage();
                        break
                      default :
                        break;
                    }
                  }
                  break;
                }
                case constDefine.ACTION_AMOUNT_EXCHANGE_COUPON: {
                  let couponId = data.couponId.toString();
                  let type = data.type;
                  this.$sqlite.insert('insert into gift_read (type, gift_id) values (?, ?);', [type, couponId]);
                  this.$store.commit(mutationTypes.setPublicCommDialogData,{
                    isShowDialog: true,
                    outerContent: data.msg,
                    isResultEvent: routerName === 'Gift',
                    eventName: constDefine.ACTION_AMOUNT_EXCHANGE_COUPON,
                  });
                  break;
                }
                case constDefine.ACTION_LOYALTY_CARD_EXCHANGE: {
                  if(routerName === 'LoyaltyCardExchange' || routerName === 'LoyaltyCardExchangeDetail') {
                    this.$store.commit(mutationTypes.setPublicCommDialogData,{
                      isShowDialog: true,
                      outerContent: data.msg,
                      isResultEvent: true,
                      eventName: constDefine.ACTION_LOYALTY_CARD_EXCHANGE,
                    });
                  }
                  break;
                }
                case constDefine.ACTION_GO_LOYALTY_CARD: {
                  //跳到禮物盒-集點卡
                  if (this.$auth.isAdminLogin()) {
                    let id = data.id;
                    let type = data.type;
                    this.$sqlite.insert('insert into gift_read (type, gift_id) values (?, ?);', [type, id]);
                  }
                  break;
                }
                  case constDefine.ACTION_GO_Gift_Pack_Detail: {
                      if (this.$auth.isAdminLogin()) {
                          let id = data.id;
                          let type = data.type;
                          this.$sqlite.insert('insert into gift_read (type, gift_id) values (?, ?);', [type, id]);
                      }
                      break;
                  }
                  case constDefine.ACTION_GO_COUPON_RECORD: {
                      //NOTE 統一用 checkUseCoupon 方式
                      // let type = data.type;
                      // if (type === "useCoupon" && routerName === "CouponPage") {
                      //     this.$store.commit(mutationTypes.setPublicCommDialogData, {
                      //         isShowDialog: true,
                      //         outerContent: data.msg,
                      //         isResultEvent: true,
                      //         eventName: type,
                      //     });
                      // }

                      break;
                  }
                default :
                  break;
              }
            },
            onPublicDialogResult(result) {
                this.$store.commit(mutationTypes.setPublicCommDialogData,{
                  ...this.defaultPublicCommDialogData,
                  isShowDialog: false,
                  result: result,
                  isResultEvent: this.$store.state.publicCommDialogData.isResultEvent,
                });
            },

            /** 底部TabBar按鈕事件 */
            onTabBarClick: function (name) {
                this.$public.addGAEventLog(`click_tab_${name}`);
            },
            /** 商圈相關頁網頁版才有底部按鈕 */
            onChange(val){
                this.isShopArea = val
            },
            windowWidth(){
                let fullWidth = window.innerWidth; //監聽裝置寬度
                this.IsWideScreen = fullWidth >= 1024;
            },

            /** screenshot監聽成功 */
            successCallbackScreenshot: function(result) {
                console.log(result); // true - enabled, false - disabled
            },
            /** screenshot監聽失敗 */
            errorCallbackScreenshot: function(error) {
                console.log(error);
            },
        }
    }
</script>

<style scoped>

</style>
